export const AgentConstants = {
    SIGNUP_REQUEST: 'AGENT_REGISTER_REQUEST',
    SIGNUP_SUCCESS: 'AGENT_REGISTER_SUCCESS',
    SIGNUP_FAILURE: 'AGENT_REGISTER_FAILURE',

    LOGIN_REQUEST: 'AGENT_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'AGENT_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'AGENT_LOGIN_FAILURE',
    LOGIN_SUCCESS_VERIFY_EMAIL: 'AGENT_LOGIN_SUCCESS_VERIFY_EMAIL',

    SHOW_AGENTS_REQUEST: 'SHOW_AGENTS_REQUEST',
    SHOW_AGENTS_SUCCESS: 'SHOW_AGENTS_SUCCESS',
    SHOW_AGENTS_FAILURE: 'SHOW_AGENTS_FAILURE',
    
    AGENT_LOGOUT: 'AGENT_LOGOUT',
    
    UPDATE_REQUEST: 'AGENT_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'AGENT_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'AGENT_UPDATE_FAILURE',

    GETALL_REQUEST: 'AGENT_GETALL_REQUEST',
    GETALL_SUCCESS: 'AGENT_GETALL_SUCCESS',
    GETALL_FAILURE: 'AGENT_GETALL_FAILURE',

    DELETE_REQUEST: 'AGENT_DELETE_REQUEST',
    DELETE_SUCCESS: 'AGENT_DELETE_SUCCESS',
    DELETE_FAILURE: 'AGENT_DELETE_FAILURE' ,
    
    REMOVE_LISTING_REQUEST: 'REMOVE_LISTING_REQUEST',
    REMOVE_LISTING_SUCCESS: 'REMOVE_LISTING_SUCCESS',
    REMOVE_LISTING_FAILURE: 'REMOVE_LISTING_FAILURE',

    DELETE_LISTING_REQUEST: 'DELETE_LISTING_REQUEST',
    DELETE_LISTING_SUCCESS: 'DELETE_LISTING_SUCCESS',
    DELETE_LISTING_FAILURE: 'DELETE_LISTING_FAILURE',

    FETCH_SINGLE_AGENT_REQUEST: 'FETCH_SINGLE_AGENT_REQUEST',
    FETCH_SINGLE_AGENT_SUCCESS: 'FETCH_SINGLE_AGENT_SUCCESS',
    FETCH_SINGLE_AGENT_FAILURE: 'FETCH_SINGLE_AGENT_FAILURE',

    FETCH_AGENT_WISHLIST_REQUEST: 'FETCH_AGENT_WISHLIST_REQUEST',
    FETCH_AGENT_WISHLIST_SUCCESS: 'FETCH_AGENT_WISHLIST_SUCCESS',
    FETCH_AGENT_WISHLIST_FAILURE: 'FETCH_AGENT_WISHLIST_FAILURE',

    
    FETCH_PIONEER_AGENTS_REQUEST: 'FETCH_PIONEER_AGENTS_REQUEST',
    FETCH_PIONEER_AGENTS_SUCCESS: 'FETCH_PIONEER_AGENTS_SUCCESS', 
    FETCH_PIONEER_AGENTS_FAILURE: 'FETCH_PIONEER_AGENTS_FAILURE'


};

